module.exports = __webpack_public_path__ + "static/media/vapi_ai.6e8e1428.png";